var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHypha(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 139 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#9ea0a0;}.cls-3{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 41.02,
    height: 41,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "0 0 41.02 0 41.02 41 0 41 0 0"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-46-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "cls-2",
    points: "65.23 17.01 55.77 17.01 55.77 8 51 8 51 31 55.77 31 55.77 21.08 65.23 21.08 65.23 31 70 31 70 8 65.23 8 65.23 17.01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "cls-2",
    d: "M81.7,20.38c-.61,1.9-1.23,4.14-1.86,6.74h-.07c-.5-2.24-1.1-4.48-1.77-6.74L76.35,15H71.61l4.55,13.07c.32.88.53,1.51.62,1.89a4,4,0,0,1,.14,1,2.41,2.41,0,0,1-.8,1.88,3.14,3.14,0,0,1-2.14.71,5.06,5.06,0,0,1-1.71-.25v3.54a10,10,0,0,0,2.31.25A9.38,9.38,0,0,0,78,36.56a5.59,5.59,0,0,0,2.39-1.84,13,13,0,0,0,1.82-3.55L88,15H83.44Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-2",
    d: "M99.34,26.72A3,3,0,0,1,96.8,28.1a2.81,2.81,0,0,1-2.43-1.35A6.5,6.5,0,0,1,93.45,23a6.54,6.54,0,0,1,.92-3.72A2.81,2.81,0,0,1,96.8,18a3,3,0,0,1,2.54,1.38,6.43,6.43,0,0,1,1,3.69,6.47,6.47,0,0,1-1,3.68m2.4-11.09a6.07,6.07,0,0,0-3.51-1,5.55,5.55,0,0,0-2.66.66,5.1,5.1,0,0,0-2,1.87h-.07V15h-4.3V36.92h4.43V29.14h.06a5,5,0,0,0,2,1.72,5.58,5.58,0,0,0,2.61.62,6,6,0,0,0,3.5-1,6.66,6.66,0,0,0,2.31-3,11.35,11.35,0,0,0,.81-4.44,11.18,11.18,0,0,0-.83-4.45,6.77,6.77,0,0,0-2.34-3",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-2",
    d: "M116.15,14.62a5.73,5.73,0,0,0-2.45.54,5.37,5.37,0,0,0-2,1.61h-.06V8.55h-4.43V31.07h4.43v-8.6a5.22,5.22,0,0,1,.87-3.25,2.77,2.77,0,0,1,2.29-1.12,2.54,2.54,0,0,1,2.07.89,4,4,0,0,1,.75,2.65v9.43h4.43V21.2a6.93,6.93,0,0,0-1.58-4.89,5.69,5.69,0,0,0-4.34-1.69",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "cls-2",
    d: "M134.28,24.3a7,7,0,0,1-.19,1.85,2.65,2.65,0,0,1-.72,1.22,2.9,2.9,0,0,1-1.13.68,4.16,4.16,0,0,1-1.4.24,2.55,2.55,0,0,1-1.76-.56,1.89,1.89,0,0,1-.62-1.47,1.78,1.78,0,0,1,.6-1.45,4.36,4.36,0,0,1,2-.76,31.39,31.39,0,0,1,3.22-.35Zm4.28,2.37V20.85a6.17,6.17,0,0,0-1.74-4.76,9.12,9.12,0,0,0-10.23,0,5.47,5.47,0,0,0-1.9,4H129a2.58,2.58,0,0,1,.74-1.79,2.68,2.68,0,0,1,1.92-.64,2.64,2.64,0,0,1,1.93.69,2.94,2.94,0,0,1,.69,2.15V21c-1.32.09-2.67.23-4,.44a9.6,9.6,0,0,0-4.8,1.81A4.2,4.2,0,0,0,124,26.58a4.54,4.54,0,0,0,1.49,3.49,5.63,5.63,0,0,0,4,1.38,6,6,0,0,0,5.22-2.53h.06a9.12,9.12,0,0,0,.22,2.15h4a17.55,17.55,0,0,1-.44-4.4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "cls-2",
    d: "M28.7,31.42H25.16a.18.18,0,0,1-.18-.17c0-7.21-2.8-8.28-5.72-9.4-.4-.16-1-.39-1.18-.49s-.26-.11-.26.06v9.82a.19.19,0,0,1-.19.19H14.09a.19.19,0,0,1-.18-.19v-21a1,1,0,0,1,.55-.88l2.93-1.47a.3.3,0,0,1,.43.27v7.23c0,1.55.47,1.87,2.85,2.79,3.25,1.25,8.16,3.14,8.22,13a.19.19,0,0,1-.19.18M30.58,0H10.44A10.43,10.43,0,0,0,0,10.44V30.56A10.43,10.43,0,0,0,10.44,41H30.58A10.43,10.43,0,0,0,41,30.56V10.44A10.43,10.43,0,0,0,30.58,0",
    transform: "translate(0)"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypha);
export default __webpack_public_path__ + "static/media/hypha.047818a86b1cc095490e2f3d9f616637.svg";
export { ForwardRef as ReactComponent };